import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "../use-api-context"
import { fetchExternalMCPServers } from "./api"

export function useFetchExternalMCPServers(options?: { enabled?: boolean; chatThreadId?: string }) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["external-mcp-servers", options?.chatThreadId],
    queryFn: async () => {
      const context = await getContext()
      return fetchExternalMCPServers(context, options?.chatThreadId)
    },
    enabled: options?.enabled ?? true,
    staleTime: 1000 * 60 * 5,
  })
}
